import secondaryComponents from "../../..";
import { useProducts } from "./useProductTable";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import styles from "./styles.module.scss";
import { RoutedModal } from "../../../../common";
import { OtherDetails } from "../OtherDetails";
import { ExpenseDepartmentForm } from "../../ExpenseDepartmentForm";

export const ProductTable = ({
  bulkForm,
  setBulkForm = () => {},
  ...validationParams
}) => {
  const { instance, isOtherDetails, views, setViews, setIsOtherDetails } =
    useProducts({
      bulkForm,
      setBulkForm,
      ...validationParams,
    });

  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <div className={`${globalStyles.tableWrapper} ${styles.pOFormTable}`}>
        {/* table section */}
        <secondaryComponents.TableHelper
          getTableBodyProps={getTableBodyProps}
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          rows={rows}
          prepareRow={prepareRow}
          classNames={`${styles.tableSection}`}
          hasAction={true}
        >
          <div className="py-5 text-center">
            <h5>Please select a store above before you can create expenses</h5>
          </div>
        </secondaryComponents.TableHelper>
      </div>

      <RoutedModal
        isActive={isOtherDetails !== null}
        closeModal={() => setIsOtherDetails(null)}
        width={850}
        headerTitle="Add Other Details"
        style={{ height: "auto" }}
        closeViaOverlay={false}
      >
        <OtherDetails
          itemInfo={isOtherDetails}
          bulkForm={bulkForm}
          setBulkForm={setBulkForm}
          closeModal={() => setIsOtherDetails(null)}
          {...validationParams}
        />
      </RoutedModal>

      {/* Create expense category */}
      <RoutedModal
        isActive={views?.isCategory}
        width="550px"
        headerTitle="Create Expense Category"
        closeModal={() => setViews((prev) => ({ ...prev, isCategory: false }))}
        style={{ height: "auto" }}
      >
        <secondaryComponents.CreateExpenseCategory
          closeWidget={() =>
            setViews((prev) => ({ ...prev, isCategory: false }))
          }
        />
      </RoutedModal>

      {/* Create expense department */}
      <RoutedModal
        isActive={views?.isDepartment}
        width="550px"
        headerTitle="Create Department"
        closeModal={() =>
          setViews((prev) => ({ ...prev, isDepartment: false }))
        }
        style={{ height: "auto" }}
      >
        <ExpenseDepartmentForm
          closeModal={() =>
            setViews((prev) => ({ ...prev, isDepartment: false }))
          }
        />
      </RoutedModal>
    </>
  );
};
